import type React from "react";
import { ReactComponent as Svg } from "./assets/custom-chip.svg";
import * as styles from "./Icon.module.scss";

type ChipProps = React.SVGProps<SVGSVGElement>;

export const Chip = ({ className, ...props }: ChipProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
